import { render, staticRenderFns } from "./RepaymenDetail.vue?vue&type=template&id=1b1adbf1&scoped=true&"
import script from "./RepaymenDetail.vue?vue&type=script&lang=js&"
export * from "./RepaymenDetail.vue?vue&type=script&lang=js&"
import style0 from "./RepaymenDetail.vue?vue&type=style&index=0&id=1b1adbf1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1adbf1",
  null
  
)

export default component.exports